import {
  Sidebar,
  SidebarProvider,
  SidebarRail,
  useSidebar,
} from '@/app/_components/ui/sidebar';
import { AppSidebarHeaderSection } from './app-sidebar-header-section';
import { AppSidebarNavigation } from './app-sidebar-navigation';
import { AppSidebarUserProfile } from './sidebar-user-profile';

export function AppSidebarProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  return <SidebarProvider>{children}</SidebarProvider>;
}

export function AppSidebar() {
  const { state } = useSidebar();
  const isCollapsed = state === 'collapsed';

  return (
    <Sidebar collapsible="icon" variant="inset">
      <AppSidebarHeaderSection isCollapsed={isCollapsed} />
      <AppSidebarNavigation isCollapsed={isCollapsed} />
      <AppSidebarUserProfile isCollapsed={isCollapsed} />
      <SidebarRail />
    </Sidebar>
  );
}
